/*
 * ============================================================
 * CASE FILTER NORMALIZATION
 * ============================================================
 *
 * Shared by:
 *
 * - React case/filter routing
 * - sitemap generation
 *
 *
 * IMPORTANT:
 *
 * Keep URL normalization here so the frontend and server/build
 * tooling can never generate different filter slugs.
 */

export const normalizeCaseFilter = (
	filter,
) => {
	const raw =
		String(
			filter ??
				"",
		)
			.trim()
			.toLowerCase();


	if (
		!raw ||
		raw ===
			"all"
	) {
		return "all";
	}


	if (
		raw ===
			"solution" ||
		raw ===
			"solutions"
	) {
		return "solution";
	}


	const slug =
		raw
			.normalize(
				"NFKD",
			)
			.replace(
				/[\u0300-\u036f]/g,
				"",
			)
			.replace(
				/&/g,
				" and ",
			)
			.replace(
				/['’]/g,
				"",
			)
			.replace(
				/[^a-z0-9]+/g,
				"-",
			)
			.replace(
				/-+/g,
				"-",
			)
			.replace(
				/^-+|-+$/g,
				"",
			);


	return slug ||
		"all";
};